import React, { useContext, useEffect } from 'react'
import styles from './styles.module.scss'
import {
  generateMetricPercentage,
  generateTimeSpent,
} from "src/services/conversationMetrics.service";
import _ from "lodash";
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux/store';
import { Conversation } from 'src/types/conversations';
import cx from "classnames"
import { fetchConversation, fetchConversations } from 'src/redux/actions/conversation';
import { useDispatch } from 'react-redux';
import TimeLine from '../../components/timeLine';
import { DealRoomContext } from '../../components/context';

const ActivityPage = () => {
  const dispatch = useDispatch();
  const { dealRoom } = useContext(DealRoomContext);
  const calculateDealValue = (opportunities) => {
    const totalDealValue = opportunities.reduce(
      (totalDealValue, opportunity) => totalDealValue + opportunity.amount,
      0,
    );
    return totalDealValue;
  };
  const shareId = _.get(dealRoom, "shareId", "");
  const {
    conversation,
    loading,
  } = useSelector((state: RootState) => {
    const conversationState = _.get(
      state.conversations,
      `conversation.${shareId}`,
      {},
    );
    return {
      conversation: _.get(conversationState, `item`, {}) as Conversation,
      assets: _.get(conversationState, `assets`, []),
      sections: _.get(conversationState, `sections`, []),
      recipients: _.get(conversationState, `recipients`, {}),
      loadingAssets: _.get(conversationState, `loadingAssets`, false),
      loading: _.get(conversationState, `loading`, false),
      loaded: _.get(conversationState, `loaded`, false),
      conversationState,
      isListEmpty: _.get(state.conversations.conversations, "items", []).length === 0 && !_.get(state.conversations.conversations, "loading", false),
    }
  });

  return (
    <div className={styles.activityContainer}>
      <div className={styles.infoCardsContainer}>
        <Metrics
          metricValue={generateMetricPercentage(
            _.get(conversation, "uniqueEmailOpens", 0) /
            _.get(conversation, "totalRecipients", 0),
          )}
          icon="paperflite-mail-open"
          metricName="email open rate"
          disabled={_.get(conversation, "uniqueEmailOpens", 0) === 0}
        />
        <Metrics
          metricValue={generateMetricPercentage(
            _.get(conversation, "uniqueLinkClicks", 0) /
            _.get(conversation, "totalRecipients", 0),
          )}
          icon="paperflite-click-rate"
          metricName="link click rate"
          disabled={_.get(conversation, "uniqueLinkClicks", 0) === 0}
        />
        <Metrics
          metricValue={
            generateTimeSpent(_.get(conversation, "totalTimeSpent", 0)) ||
            "00 : 00"
          }
          icon="paperflite-clock"
          metricName="total time spent"
          disabled={_.get(conversation, "totalTimeSpent", 0) === 0}
        />
        {/* {_.size(_.get(conversation, "opportunities")) > 0 && (
        <Metrics
          metricValue={calculateDealValue(conversation.opportunities)}
          icon="paperflite-dollar"
          metricName="deal value"
          action={
            <i
              className={cx("paperflite-dropdown", {
                [styles.toggleAction]: toggleAction,
              })}
              onClick={() => {
                setToggleAction(!toggleAction);
                handleDealValueBreakup();
              }}
            />
          }
        />
      )} */}
      </div>
      {loading && <div>Loading...</div>}
      {conversation && <TimeLine
        show={true}
        onClose={() => ""}
        conversation={conversation}
      />}
    </div>

  )
}

interface IMetrics {
  metricValue: string;
  metricName: string;
  icon: string;
  action?: React.ReactNode;
  disabled?: boolean;
}

export const Metrics: React.FC<IMetrics> = ({
  metricValue,
  metricName,
  icon,
  action,
  disabled = false
}) => {
  return (
    <div className={styles.infoCard}>
      <div className={styles.metrics}>
        <span className={cx(styles.metricValue, {
          [styles.disabled]: disabled
        })}>{metricValue}</span>
        <i className={cx(icon, styles.icon)} />
      </div>

      <div className={styles.actions}>
        <span className={styles.metricName}>{metricName}</span>
        {action && action}
      </div>
    </div>
  );
};

export default ActivityPage;